// extracted by mini-css-extract-plugin
export var productImage = "_zv-0";